<template>
    <v-navigation-drawer class="MobileNavDrawer"
        fixed
        clipped
        app
        disable-route-watcher
        disable-resize-watcher
        v-model="display">
        <Menu :menuItems="menuItems" :horizontal="false" @url-clicked="navigate($event.route, $event.newTab)"></Menu>
    </v-navigation-drawer>
</template>
<script>
import Menu from './Menu.vue';

export default {
    props: ['menuItems'],
    components: {
        Menu
    },
    computed: {
        display: {
            get() {
                return this.$store.state.GeneralStore.displayNavDrawer;
            },
            set(value) {
                this.$store.commit("GeneralStore/setDisplayNavDrawer", value);
            }
        }
    },
    methods: {
        navigate(route, newTab = false) {
            console.log("bloop");
            this.$store.commit("GeneralStore/setDisplayNavDrawer", false);
            this.$emit('url-clicked', {
                route,
                newTab
            })
        }
    }
}
</script>

<style>

.MobileNavDrawer {
    z-index: 15; /* Must be greater than 10 to appear over view contents */
}

</style>